import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("菜单")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("功能")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("字段")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("其他")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("PC端")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("移动端")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("小程序")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("其他")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("停用")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { propTypes } from '@/utils/propTypes';

/* Api */
import { ModDetailApi } from '@/apis/modules/modules.api';

/* Types */
import { ModuleBase } from '@/apis/modules/modules.type';



export default /*#__PURE__*/_defineComponent({
  props: {
    moduleId: propTypes.string.def(''),
    isCreate: propTypes.bool.def(false)
},
  setup(__props, { expose }) {

const props = __props

const loading = ref<boolean>(false)
const formRef = ref<ComponentRef<typeof ElForm>>()

const mobuleSchema = ref<ModuleBase>({
    pid: '',
    name: '',
    code: '',
    path: '',
    type: 'Menu',
    app: 'PC',
    is_enabled: 'N',
    meta: '',
    remark: '',
    sort: 0,
    component_path: ''
})

const formRules = reactive<FormRules>({
    code: [
        { required: true, message: '模块标识不能为空', trigger: 'blur' },
    ],
    name: [
        { required: true, message: '模块名称不能为空', trigger: 'blur' },
    ],
    path: [
        { required: true, message: '模块路径不能为空', trigger: 'blur' },
    ],
    component_path: [
        { required: true, message: '页面相对路径不能为空', trigger: 'blur' },
    ],

})



const methods: {
    getFormData: () => ModuleBase
} = {
    getFormData: () => {
        const form = unref(formRef)
        return mobuleSchema?.value as ModuleBase
    }
}

/* 读取模板信息 */
const getModuleData = (moduleId: string) => {
    if (!props.isCreate) {
        loading.value = true
        ModDetailApi(moduleId).then((res) => {

            if (!res.succeeded) {
                ElMessage.error(`读取模块型明细数据失败，可能的原因：${res.errors}`)
            }
            else {
                mobuleSchema.value = res.data
            }

        }).finally(() => {
            loading.value = false
        })
    } else {
        mobuleSchema.value.pid = props.moduleId
    }
}

getModuleData(props.moduleId)
expose({ formRef, methods })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "formRef",
    ref: formRef,
    model: mobuleSchema.value,
    "label-width": "150px",
    "label-position": 'right',
    rules: _unref(formRules)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "模块标识(唯一)",
        prop: "code"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: mobuleSchema.value.code,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mobuleSchema.value.code) = $event)),
            type: "text",
            placeholder: "请输入模块标识"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "模块名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: mobuleSchema.value.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mobuleSchema.value.name) = $event)),
            type: "text",
            placeholder: "请输入模块名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "页面Url",
        prop: "path"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: mobuleSchema.value.path,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mobuleSchema.value.path) = $event)),
            type: "text",
            placeholder: "请输入页面Url"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "组件文件Url",
        prop: "component_path"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: mobuleSchema.value.component_path,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mobuleSchema.value.component_path) = $event)),
            type: "text",
            placeholder: "请输入组件文件Url"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Meta参数(JSON)",
        prop: "meta"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: mobuleSchema.value.meta,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((mobuleSchema.value.meta) = $event)),
            type: "text",
            placeholder: "请输入Meta参数"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "类型",
        prop: "type"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: mobuleSchema.value.type,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((mobuleSchema.value.type) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "Menu" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "Plugins" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "Colunms" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "Other" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "设备类型",
        prop: "app"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: mobuleSchema.value.app,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mobuleSchema.value.app) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "PC" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "App" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "Mini" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "Other" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "启用模块",
        prop: "is_enabled"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: mobuleSchema.value.is_enabled,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((mobuleSchema.value.is_enabled) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "Y" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "N" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            "show-word-limit": "",
            maxlength: "50",
            modelValue: mobuleSchema.value.remark,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((mobuleSchema.value.remark) = $event)),
            rows: "4",
            placeholder: "备注"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"])), [
    [_directive_loading, loading.value]
  ])
}
}

})